import {
  Box,
  Button,
  ListItem,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  UnorderedList,
} from "@chakra-ui/react";
import { FunctionComponent } from "react";
import { RuleImportError } from "./helpers";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  errors: RuleImportError[];
  context: "import" | "export";
};

export const RuleImportErrorsModal: FunctionComponent<Props> = ({
  isOpen,
  onClose,
  errors,
  context,
}) => {
  const isExport = context === "export";
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      scrollBehavior="inside"
      size="lg"
      isCentered
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {isExport ? "Export errors" : "Import errors"}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text mb="4">
            {isExport
              ? "Export failed on some rules. Review and address the following before retrying to export:"
              : "Import failed on some rules. Review and address the following warnings before retrying to import:"}
          </Text>
          {errors.map((error, index) => (
            <Box key={`rule-import-error-${index}`} mb="4">
              <Text fontWeight="bold">{error.heading}</Text>
              <UnorderedList>
                {error.messages.map((message, messageIndex) => (
                  <ListItem key={`message-${messageIndex}`}>{message}</ListItem>
                ))}
              </UnorderedList>
            </Box>
          ))}
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose}>Done</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
